import { getDefaultPageRoute } from 'helpers/redirect';
import { createSelector } from 'reselect';

const getEnvironmentProperties = ({ portal }) => {
    return portal.environmentProperties.data;
};

const getLoadingStatus = ({ portal }) => {
    return portal.environmentProperties.loadingStatus;
};

const getDefaultPage = () => {
    return getDefaultPageRoute();
};

const getUserData = ({ overview }) => {
    return overview.user.data;
};

const getSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0];
};

export const getModel = createSelector([
    getEnvironmentProperties,
    getLoadingStatus,
    getDefaultPage,
    getUserData,
    getSelectedOrganization
], (
    environmentProperties,
    loadingStatus,
    defaultPage,
    userData,
    selectedOrganization
) => {
    return {
        environmentProperties,
        loadingStatus,
        defaultPage,
        userData,
        selectedOrganization
    };
});
